var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.columnPanel }, [
    _c("div", { class: _vm.$style.columnsPanelHeaderRow }, [
      _c("span", { class: _vm.$style.columnsPanelRowNumber }, [_vm._v("#")]),
      _c("span", { class: _vm.$style.columnsPanelRowName }, [
        _vm._v("Column Name"),
      ]),
      _c("span", [_vm._v("Manage")]),
    ]),
    _c(
      "div",
      { class: _vm.$style.columnsPanelBody },
      [
        _vm._l(_vm.columns, function (column, index) {
          return _c(
            "div",
            {
              key: column,
              class: {
                [_vm.$style.columnsPanelRow]: true,
                [_vm.$style.firstHidden]:
                  _vm.visibleColumns > 0 && index === _vm.visibleColumns,
              },
            },
            [
              _c("span", { class: _vm.$style.columnsPanelRowNumber }, [
                _vm._v(_vm._s(index + 1)),
              ]),
              _c("span", { class: _vm.$style.columnsPanelRowName }, [
                _vm._v(_vm._s(_vm.getColumn(column).text)),
              ]),
              _c("span", { class: _vm.$style.columnsPanelRowIcons }, [
                index > 0 && _vm.canReposition
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            return _vm.pushUp(index)
                          },
                        },
                      },
                      [_vm._v("publish")]
                    )
                  : _vm._e(),
                _vm.canRemove
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function ($event) {
                            return _vm.removeColumn(column)
                          },
                        },
                      },
                      [_vm._v("remove_circle_outline")]
                    )
                  : _vm._e(),
              ]),
            ]
          )
        }),
        _vm.canRemove
          ? _c(
              "div",
              { class: _vm.$style.otherColumns },
              _vm._l(_vm.otherColumns, function (column) {
                return _c(
                  "div",
                  { key: column.id, class: _vm.$style.columnsPanelRow },
                  [
                    _c("span", { class: _vm.$style.columnsPanelRowName }, [
                      _vm._v(_vm._s(column.text)),
                    ]),
                    _c(
                      "span",
                      { class: _vm.$style.columnsPanelOtherRowIcons },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            on: {
                              click: function ($event) {
                                return _vm.addColumn(column.id)
                              },
                            },
                          },
                          [_vm._v("add_circle_outline")]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }